export default __webpack_public_path__ + "static/media/right-side50.5d97b031.png";